import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant", // you can change to "smooth"
    });
  }, [pathname, search]); // 🔥 also watch query params

  return null;
};

export default ScrollToTop;